<template>
    <div class="filter-menu">
        <div class="filter-menu-header">
            {{phrases.TEXT_FILTER_PIZZA}}
            <div class="button-close-filter" @click="openFilter">
                <span class="pp-icon pp-icon-close"></span>
            </div>
        </div>
        <div class="filter-menu-body">
            <div class="product-filter-wrapper">
                <div class="product-filter-item" v-for="(filter, index) in filters" :key="index" :class="{'checked': filter.selected}" @click="checkFilter(filter.id)">
                    <div class="product-filter-name">{{filter.title}}
                        <span v-if="filter.count">({{filter.count}})</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="filter-menu-footer">
            <div class="button-filter-clear" @click="clearFilter">{{phrases.TEXT_BUTTON_CLEAR_FILTER}}</div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Utils from "./Utils";

    export default {
        name: "FilterMenu",
        data: function(){
            return{
                selectFilter: false,
            };
        },
        methods: {
            checkFilter: function (filter_id) {
                this.$store.dispatch({
                    type: 'catalog/setSelectFilter',
                    filter_id: filter_id,
                });
            },
            clearFilter: function () {
                this.$store.commit('catalog/clearSelectedFilter');
            }
        },
        computed: {
            ...mapGetters('app', {
                phrases: 'getPhrases',
            }),
            ...mapGetters('catalog', {
                filters: 'getFilters',
            }),
        },
        mixins: [Utils],
    }
</script>

<style scoped>

</style>
